import { Button, Flex, theme } from "antd"
import { DownloadOutlined, InfoCircleOutlined } from "@ant-design/icons"
import { useState } from "react"
import { useParams } from "react-router-dom"
import { ReportSummaryModal } from "./ReportSummaryModal.tsx"
import { useGenerateCSVReportMutation, useGetReport } from "../../api/report/report.ts"

export const ReportControls = () => {
    const { reportId } = useParams()
    const { token } = theme.useToken()
    const { data: response } = useGetReport(reportId)
    const [isModalOpen, setIsModalOpen] = useState(false)
    const { mutate, isPending } = useGenerateCSVReportMutation()
    const toggleModal = () => {
        setIsModalOpen((prevState) => !prevState)
    }

    const reportDocument = response?.data

    return <Flex
        style={{ marginLeft: 'auto' }}
        justify="flex-end"
        gap={token.marginXS}
    >
        <Button
            icon={<InfoCircleOutlined/>}
            onClick={toggleModal}
        >
            Summary
        </Button>
        <Button
            loading={isPending}
            icon={<DownloadOutlined/>}
            type="primary"
            onClick={() => mutate({ reportId: reportId! })}
        >
            CSV
        </Button>
        {!!reportDocument &&
            <ReportSummaryModal
                reportDocument={reportDocument}
                isModalOpen={isModalOpen}
                toggleModal={toggleModal}/>
        }
    </Flex>
}
